import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import axios from './axiosConfig'; // 导入你自定义封装的 axios 实例
import './DashboardsOverview.css';

const DashboardsOverview: React.FC = () => {
    const [folders, setFolders] = useState<{ id: number, name: string }[]>([]);

    useEffect(() => {
        const fetchFolders = async () => {
            try {
                const response = await axios.get('/api/folders'); // 使用自定义 axios 实例发起请求
                const data = response.data;
                console.log('Fetched folders:', data);

                if (data && Array.isArray(data.folders)) {
                    setFolders(data.folders);
                } else {
                    console.error('Expected an array but got:', data);
                    setFolders([]);
                }
            } catch (error) {
                console.error('Error fetching folders', error);
                setFolders([]);
            }
        };

        fetchFolders();
    }, []);

    return (
        <Container fluid className="full-height">
            <Row className="full-height">
                {/* 左侧菜单项 */}
                <Col md={3} className="dashboard-sidebar">
                    <h2>Menu</h2>
                    {/* Folder 菜单项 */}
                    {folders.map(folder => (
                        <div className="menu-item" key={folder.id}>
                            <Link to={`/dashboard/folder/${folder.name}`} className="menu-link">
                                <FontAwesomeIcon icon={faFolder} className="icon-button" />
                                <span className="menu-item-label">{folder.name}</span>
                            </Link>
                        </div>
                    ))}

                    {/* New Dashboard 菜单项 */}
                    <div className="menu-item">
                        <Link to="/dashboard/create" className="menu-link">
                            <span className="menu-item-label">Create New Dashboard</span>
                        </Link>
                    </div>
                </Col>

                {/* 右侧内容 */}
                <Col md={9} className="full-height">
                    {/* 这里可以放一些默认的静态内容或者直接留空 */}
                    <h1>Welcome to the Dashboard</h1>
                    <p>Select an option from the menu to get started.</p>
                </Col>
            </Row>
        </Container>
    );
};

export default DashboardsOverview;
